module.exports = __webpack_public_path__ + "static/media/5.bd5ddf66.png";